// A wrapper around the CustomButton component for standardizing the button in the new Revamp

import React from "react";
import CustomButton from "./CustomButton";
import { StyleSheet } from "react-native";
import useResponsiveScreen from "../../../../hooks/useResponsiveScreen";

export const NewCustomActionButton = ({ text, onPress, leftIcon }) => {
  const { isXLarge } = useResponsiveScreen();
  return (
    <CustomButton
      text={text}
      size="s"
      weight="bold"
      styleType="primaryLight"
      style={[isXLarge ? {} : styles.fullWidthButton, { width: "fit-content" }]}
      onPress={onPress}
      leftIcon={leftIcon}
      rightIcon={null}
      textStyle={{ fontWeight: "bold" }}
      disabled={false}
      textProps={{}}
    />
  );
};

const styles = StyleSheet.create({
  fullWidthButton: {
    width: "100%",
  },
});
